import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ConfigServerService, CustomHttp } from '../../../../core';
import { GrupoClassificacaoClassificacao } from '../grupo-classificacao-classificacao';

@Injectable({
    providedIn: 'root'
})
export class GrupoClassificacaoClassificacaoHttpService {
    private pathApi: string;

    constructor(configServerService: ConfigServerService,
                private customHttp: CustomHttp) {
        this.pathApi = `${configServerService.getPathApi()}/grupoclassificacao`;
    }

    /** Pesquisa todas as classificações do grupo informado */
    search(idGrupoClassificacao): Observable<GrupoClassificacaoClassificacao[]> {
        return this.customHttp.get<GrupoClassificacaoClassificacao[]>(`${this.pathApi}/${idGrupoClassificacao}/classificacoes`);
    }
}
